// Certificaciones que se anexan al final del PDF GC (después de las evidencias
// GOR-F-012 V3), en este orden. Cada una se consulta/genera en la página oficial
// (requieren verificación humana/captcha, por eso se adjuntan manualmente).
export const CERT_TIPOS = [
  { tipo: 'fiscales', label: 'Certificación de antecedentes fiscales', entidad: 'Contraloría', consulta: 'https://www.contraloria.gov.co/web/guest/persona-natural' },
  { tipo: 'disciplinarios', label: 'Certificación de antecedentes disciplinarios', entidad: 'Procuraduría', consulta: 'https://www.procuraduria.gov.co/Pages/Consulta-de-Antecedentes.aspx' },
  { tipo: 'penales', label: 'Certificación de antecedentes penales', entidad: 'Policía Nacional', consulta: 'https://antecedentes.policia.gov.co:7005/WebJudicial/antecedentes.xhtml' },
  { tipo: 'medidas_correctivas', label: 'Certificación del Registro Nacional de Medidas Correctivas', entidad: 'RNMC', consulta: 'https://srvcnpc.policia.gov.co/PSC/frm_cnp_consulta.aspx' },
];

/** Devuelve las certificaciones (de CERT_TIPOS) que aún NO están cargadas. */
export const certificacionesFaltantes = (certificaciones = []) => {
  const cargadas = new Set((certificaciones || []).filter(c => c && c.url).map(c => c.tipo));
  return CERT_TIPOS.filter(ct => !cargadas.has(ct.tipo));
};

/** Certificaciones cargadas pero SIN fecha de expedición (la fecha va al informe). */
export const certificacionesSinFecha = (certificaciones = []) => {
  const porTipo = {};
  (certificaciones || []).forEach(c => { if (c && c.url) porTipo[c.tipo] = c; });
  return CERT_TIPOS.filter(ct => porTipo[ct.tipo] && !(porTipo[ct.tipo].fecha || '').trim());
};

/**
 * Si faltan certificaciones por cargar, o hay cargadas sin fecha de expedición,
 * retorna un mensaje indicando cuáles. Si todo está completo, retorna null.
 */
export const validarCertificaciones = (certificaciones = []) => {
  const faltan = certificacionesFaltantes(certificaciones);
  if (faltan.length > 0) {
    const lista = faltan.map(f => `• ${f.label} (${f.entidad})`).join('\n');
    const plural = faltan.length > 1;
    return `Falta${plural ? 'n' : ''} ${faltan.length} certificación${plural ? 'es' : ''} por cargar. ` +
      `Van anexas al final del PDF, después de las evidencias:\n${lista}\n` +
      `Ve a la sección "📜 Certificaciones" de la cuenta y súbela${plural ? 's' : ''}.`;
  }
  const sinFecha = certificacionesSinFecha(certificaciones);
  if (sinFecha.length > 0) {
    const lista = sinFecha.map(f => `• ${f.label}`).join('\n');
    const plural = sinFecha.length > 1;
    return `${plural ? 'Estas certificaciones están' : 'Esta certificación está'} cargada${plural ? 's' : ''} ` +
      `pero sin FECHA de expedición (esa fecha se imprime en el informe):\n${lista}\n` +
      `Selecciona la fecha en la sección "📜 Certificaciones".`;
  }
  return null;
};
